import { useState, useEffect, useMemo } from "react";
import { NETWORKS } from "../constants";

export const useCustomNetworks = () => {
  const [customNetworks, setCustomNetworks] = useState({});
  const networks = useMemo(() => ({ ...NETWORKS, ...customNetworks }), [customNetworks]);

  useEffect(() => {
    try {
      const customNetworks = JSON.parse(localStorage.getItem("custom-networks"));

      if (customNetworks && customNetworks instanceof Object) {
        setCustomNetworks(customNetworks);
      } else {
        localStorage.removeItem("custom-networks");
      }
    } catch (e) {
      localStorage.removeItem("custom-networks");
    }
  }, []);

  return useMemo(() => [customNetworks, setCustomNetworks, networks], [customNetworks, networks]);
};
